import states from "./states"
import {
  UPDATE_CAMPAIGNS_ANALYTICS__STATE,
  UPDATE_LIVE_CAMPAIGNS__STATE,
  UPDATE_HISTORIC_CAMPAIGNS_STATE,
  UPDATE_COMPONENT_STATE,
  REMOVE_UPDATED_FLAG,
} from "./actiontypes"

const mergeById = (oldArr, newArr = []) => {
  const map = new Map()
  oldArr.forEach(item => map.set(item.id, item))
  newArr.forEach(item => map.set(item.id, item))
  return Array.from(map.values())
}

const campaigns_analytics_details = (
  state = states.campaigns_analytics_details,
  action
) => {
  switch (action.type) {
    case UPDATE_CAMPAIGNS_ANALYTICS__STATE:
      return {
        ...state,
        ...action.payload,
      }

    case UPDATE_LIVE_CAMPAIGNS__STATE: {
      const data = action.payload
      const newMetrics = data.filter(item => item.componentType === "metrics")
      const newTables = data.filter(item => item.componentType === "table")

      return {
        ...state,
        liveMetrics: {
          metrics: mergeById(state.liveMetrics?.metrics || [], newMetrics),
          tables: mergeById(state.liveMetrics?.tables || [], newTables),
        },
      }
    }

    case UPDATE_HISTORIC_CAMPAIGNS_STATE: {
      const { data, apiType } = action.payload
      const newMetrics = data
        .filter(item => item.componentType === "metrics")
        .map(item => ({ ...item, apiType }))
      const newGraphs = data
        .filter(item => item.componentType === "graph")
        .map(item => ({ ...item, apiType }))
      const newTables = data
        .filter(item => item.componentType === "table")
        .map(item => ({ ...item, apiType }))

      return {
        ...state,
        historicMetrics: {
          metrics: mergeById(state.historicMetrics?.metrics || [], newMetrics),
          graphs: mergeById(state.historicMetrics?.graphs || [], newGraphs),
          tables: mergeById(state.historicMetrics?.tables || [], newTables),
        },
      }
    }

    case UPDATE_COMPONENT_STATE: {
      const { data } = action.payload

      if (!data || !data.length || !data[0]?.id) {
        return state
      }

      const updatedData = { ...data[0], updated: true }
      const targetId = updatedData.id
      const componentType = updatedData.componentType

      const updatedGraphs =
        componentType === "graph"
          ? state.historicMetrics?.graphs?.map(graph =>
              graph.id === targetId ? { ...graph, ...updatedData } : graph
            ) || []
          : state.historicMetrics?.graphs || []

      const updatedMetrics =
        componentType === "metrics"
          ? state.historicMetrics?.metrics?.map(metric =>
              metric.id === targetId ? { ...metric, ...updatedData } : metric
            ) || []
          : state.historicMetrics?.metrics || []

      return {
        ...state,
        historicMetrics: {
          ...state.historicMetrics,
          graphs: updatedGraphs,
          metrics: updatedMetrics,
        },
      }
    }

    case REMOVE_UPDATED_FLAG: {
      const { id } = action.payload

      if (!id) {
        return state
      }

      const updatedGraphs =
        state.historicMetrics?.graphs?.map(graph => {
          if (graph.id === id && graph.updated) {
            const { updated, ...graphWithoutUpdated } = graph
            return graphWithoutUpdated
          }
          return graph
        }) || []

      const updatedMetrics =
        state.historicMetrics?.metrics?.map(metric => {
          if (metric.id === id && metric.updated) {
            const { updated, ...metricWithoutUpdated } = metric
            return metricWithoutUpdated
          }
          return metric
        }) || []

      return {
        ...state,
        historicMetrics: {
          ...state.historicMetrics,
          graphs: updatedGraphs,
          metrics: updatedMetrics,
        },
      }
    }

    default:
      return state
  }
}

export default campaigns_analytics_details
